import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "TransactionDetails";
const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                <SelectInput
                    name={componentName + LOOKUP.report.common.status}
                    fullWidth={true}
                    label={LOOKUP.report.common.status}
                    floatingLabelText={LOOKUP.report.common.status}
                    hintText={LOOKUP.report.common.status}
                    options={LOOKUP.report.common.statusOption}
                    defaultValue={"0"}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-2 m-0">
                <SelectInput
                    name={componentName + "Payment"}
                    fullWidth={true}
                    label={"Payment"}
                    floatingLabelText={"Payment"}
                    hintText={"Payment"}
                    options={props.paymentOptions}
                    defaultValue={"All"}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-2 m-0">
                <SelectInput
                    name={componentName + LOOKUP.report.common.approvalType}
                    fullWidth={true}
                    label={LOOKUP.report.common.approvalTypeLabel}
                    floatingLabelText={LOOKUP.report.common.approvalTypeLabel}
                    hintText={LOOKUP.report.common.approvalTypeLabel}
                    options={LOOKUP.report.common.approvalOptions}
                    defaultValue={"0"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <AutoCompleteInput
                    name={`${componentName}ProductId`}
                    label="Search an existing product"
                    hintText="Product"
                    className={"AutoCompleteInput-searchbar"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 m-0">
                <SelectInput
                    name={`${componentName}OrderType`}
                    fullWidth={true}
                    label="Order Type"
                    floatingLabelText="Order Type"
                    defaultValue="all"
                    hintText="Order Type"
                    options={props.orderTypes}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS mb-1"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS mb-1"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 mb_xs p-0">
                <p className="purpleText"><b>Note: </b><strong className="blue-text"><i>The total amount for an order will be cleared if the order is refunded. Discount and taxes are included in total amount.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
